/**
 * @file 获取浏览器和os信息，参考 from @baidu/launch-hk
 * @author shaoyanhui
 */

export default {
    OS: [
        [
            'ios', function (ua) {
                if (/\bcpu(?: iphone)? os /.test(ua)) {
                    return /\bcpu(?: iphone)? os ([0-9._]+)/;
                }
                if (ua.indexOf('iph os ') !== -1) {
                    return /\biph os ([0-9_]+)/;
                }

                return /\bios\b/;
            }
        ],
        [
            'android', function (ua) {
                if (ua.indexOf('android') >= 0) {
                    return /\bandroid[ /-]?([0-9.x]+)?/;
                }
                if (ua.indexOf('adr') >= 0) {
                    if (ua.indexOf('mqqbrowser') >= 0) {
                        return /\badr[ ]\(linux; u; ([0-9.]+)?/;
                    }

                    return /\badr(?:[ ]([0-9.]+))?/;
                }
                return 'android';
                // return /\b(?:android|\badr)(?:[\/\- ](?:\(linux; u; )?)?([0-9.x]+)?/;
            }
        ],
        [
            'wp', function (ua) {
                if (ua.indexOf('windows phone ') !== -1) {
                    return /\bwindows phone (?:os )?([0-9.]+)/;
                }
                if (ua.indexOf('xblwp') !== -1) {
                    return /\bxblwp([0-9.]+)/;
                }
                if (ua.indexOf('zunewp') !== -1) {
                    return /\bzunewp([0-9.]+)/;
                }
                return 'windows phone';
            }
        ],
        ['symbian', /\bsymbian(?:os)?\/([0-9.]+)/],
        ['chromeos', /\bcros i686 ([0-9.]+)/],
        ['linux', 'linux'],
        ['windowsce', /\bwindows ce(?: ([0-9.]+))?/]
    ],
    BROWSER: [
        // tencent
        ['micromessenger', /\bmicromessenger\/([\d.]+)/],
        ['qq', /\bm?qqbrowser\/([0-9.]+)/],
        ['tt', /\btencenttraveler ([0-9.]+)/],
        ['weibo', /weibo__([0-9.]+)/],
        [
            'uc', function (ua) {
                if (ua.indexOf('ucbrowser/') >= 0) {
                    return /\bucbrowser\/([0-9.]+)/;
                }
                if (ua.indexOf('ubrowser/') >= 0) {
                    return /\bubrowser\/([0-9.]+)/;
                }
                if (/\buc\/[0-9]/.test(ua)) {
                    return /\buc\/([0-9.]+)/;
                }
                if (ua.indexOf('ucweb') >= 0) {
                    // `ucweb/2.0` is compony info.
                    // `UCWEB8.7.2.214/145/800` is browser info.
                    return /\bucweb([0-9.]+)?/;
                }

                return /\b(?:ucbrowser|uc)\b/;
            }
        ],
        [
            '360', function (ua) {
                if (ua.indexOf('360 aphone browser') !== -1) {
                    return /\b360 aphone browser \(([^)]+)\)/;
                }
                return /\b360(?:se|ee|chrome|browser)\b/;
            }
        ],
        ['baidu', /\b(?:ba?idubrowser|baiduhd)[ /]([0-9.x]+)/],
        [
            'baiduboxapp',
            function (ua) {
                let back = 0;
                let a;
                if (/ baiduboxapp\//i.test(ua)) {
                    if (/([\d+.]+)_(?:diordna|enohpi)_/.exec(ua)) {
                        a = /([\d+.]+)_(?:diordna|enohpi)_/.exec(ua);
                        a = a[1].split('.');
                        back = a.reverse().join('.');
                    }
                    else if (/baiduboxapp\/([\d+.]+)/.exec(ua)) {
                        a = /baiduboxapp\/([\d+.]+)/.exec(ua);
                        back = a[1];
                    }
                    return {
                        version: back
                    };
                }
                return false;
            }
        ],
        [
            'sogou', function (ua) {
                if (ua.indexOf('sogoumobilebrowser') >= 0) {
                    return /sogoumobilebrowser\/([0-9.]+)/;
                }
                if (ua.indexOf('sogoumse') >= 0) {
                    return true;
                }
                return / se ([0-9.x]+)/;
            }
        ],
        [
            'ali-ap', function (ua) {
                if (ua.indexOf('aliapp') > 0) {
                    return /\baliapp\(ap\/([0-9.]+)\)/;
                }

                return /\balipayclient\/([0-9.]+)\b/;
            }
        ],
        ['ali-tb', /\baliapp\(tb\/([0-9.]+)\)/],
        ['ali-tm', /\baliapp\(tm\/([0-9.]+)\)/],
        ['tao', /\btaobrowser\/([0-9.]+)/],
        // 厂商
        ['mi', /\bmiuibrowser\/([0-9.]+)/],
        ['oppo', /\boppobrowser\/([0-9.]+)/],
        ['vivo', /\bvivobrowser\/([0-9.]+)/],
        ['meizu', /\bmzbrowser\/([0-9.]+)/],
        ['nokia', /\bnokiabrowser\/([0-9.]+)/],
        // ["huawei", /\bhuaweibrowser\/([0-9.]+)/],
        ['samsung', /\bsamsungbrowser\/([0-9.]+)/],
        ['maxthon', /\b(?:maxthon|mxbrowser)(?:[ /]([0-9.]+))?/],
        // Opera 15 之后开始使用 Chromniun 内核，需要放在 Chrome 的规则之前。
        [
            'opera', function (ua) {
                const reOperaOld = /\bopera.+version\/([0-9.ab]+)/;
                const reOperaNew = /\bopr\/([0-9.]+)/;
                return reOperaOld.test(ua) ? reOperaOld : reOperaNew;
            }
        ],
        ['edge', /edge\/([0-9.]+)/],
        ['firefox', /\bfirefox\/([0-9.ab]+)/],
        ['chrome', / (?:chrome|crios|crmo)\/([0-9.]+)/],
        // Android 默认浏览器。该规则需要在 safari 之前。
        [
            'android', function (ua) {
                if (ua.indexOf('android') === -1) {
                    return;
                }
                return /\bversion\/([0-9.]+(?: beta)?)/;
            }
        ],
        ['safari', /\bversion\/([0-9.]+(?: beta)?)(?: mobile(?:\/[a-z0-9]+)?)? safari\//],
        // 如果不能被识别为 Safari，则猜测是 WebView。
        ['webview', /\bcpu(?: iphone)? os (?:[0-9._]+).+\bapplewebkit\b/]
    ],
    UA: `${navigator.userAgent} ${navigator.appVersion} ${navigator.vendor}`,
    typeOf(type) {
        return function (object) {
            return Object.prototype.toString.call(object) === `[object ${type}]`;
        };
    },
    each(object, factory) {
        for (let i = 0, l = object.length; i < l; i++) {
            if (factory.call(object, object[i], i) === false) {
                break;
            }
        }
    },
    fdetect(name, expression, ua) {
        const expr = this.typeOf('Function')(expression) ? expression.call(null, ua) : expression;
        if (!expr) {
            return null;
        }
        const info = {
            name,
            version: '0',
            codename: ''
        };
        if (expr === true) {
            return info;
        }
        if (this.typeOf('String')(expr)) {
            if (ua.indexOf(expr) !== -1) {
                return info;
            }
        }
        else if (this.typeOf('Object')(expr)) {
            const hasVersion = Object.prototype.hasOwnProperty.call(expr, 'version');
            if (hasVersion) {
                info.version = expr.version;
            }
            return info;
        }
        else if (this.typeOf('RegExp')(expr)) {
            const m = expr.exec(ua);
            if (m) {
                if (m.length >= 2 && m[1]) {
                    info.version = m[1].replace(/_/g, '.');
                }
                return info;
            }
        }
    },
    fparseItem(ua, patterns, factory, detector) {
        const self = this;
        let detected = {
            name: 'na',
            version: '0'
        };

        this.each(patterns, pattern => {
            const d = self.fdetect(pattern[0], pattern[1], ua);
            if (d) {
                detected = d;
                return false;
            }
        });
        factory.call(detector, detected.name, detected.version);
    },
    parse(UA) {
        let ua = UA || '';
        ua = ua.toLowerCase();
        const d = {};
        this.fparseItem(ua, this.OS, (name, version) => {
            const v = parseFloat(version);
            d.os = {
                name,
                version: v,
                fullVersion: version
            };
            d.os[name] = v;
        }, d);
        this.fparseItem(ua, this.BROWSER, (name, version) => {
            const mode = version;
            const v = parseFloat(version);
            d.browser = {
                name,
                version: v,
                fullVersion: version,
                mode: parseFloat(mode),
                fullMode: mode
            };
            d.browser[name] = v;
        }, d);
        return d;
    },
    getDetector() {
        return this.parse(this.UA);
    }
};
